export default "<span data-binding=\"{{model}}:text\"></span>\n";